/* eslint-disable */
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

import mixitup from 'mixitup';

export default {
  init() {
    $(window).load(() => {
      // Course recommendations
      new Swiper('.course-recommends .swiper-container', {
        spaceBetween: 40,
        pagination: {
          el: '.course-recommends .swiper-pagination',
          clickable: true
        },
      });

    // Course industries
    new Swiper('.course-industry-swiper .swiper-container', {
      slidesPerView: 2,
      spaceBetween: 18,
      breakpoints: {
        1350: {
          slidesPerView: 5
        },
        1075: {
          slidesPerView: 4
        },
        780: {
          slidesPerView: 3,
          spaceBetween: 39,
        },
        510: {
          slidesPerView: 2
        },
        360: {
          slidesPerView: 1.7
        },
        0: {
          slidesPerView: 1.4
        }
      }
    });

    // Syllabus categories
    mixitup('.syllabus-items-list', {
      selectors: {
        target: 'div.syllabus-item',
        control: '.syllabus-filter'
      },
      animation: {
        effectsIn: 'fade translateY(-100%)'
      }
    }).filter('.syllabus-0');

    // Courses periods
    mixitup('.upcoming-courses-items', {
      selectors: {
        target: 'div.upcoming-course-item',
        control: '.courses-filter'
      },
      animation: {
        effectsIn: 'fade translateY(-100%)'
      }
    }).filter('.courses-0');
  });

    // Upcoming courses
    $('.upcoming-courses-items .upcoming-course-item .course-action a').on('click', function (e) {
      e.preventDefault();

      const course = $(this).data('course');
      const type = $(this).data('type');
      const year = $(this).data('year');
      const month = $(this).data('month');

      const contactForm = $('.footer-signup-section .signup-form form.wpcf7-form');

      contactForm.find('input[type=hidden]#course').val(course);
      contactForm.find('input[type=hidden]#type').val(type);
      contactForm.find('input[type=hidden]#year').val(year);
      contactForm.find('input[type=hidden]#month').val(month);

      $('body, html').animate({
        scrollTop: $('.footer-signup-section').offset().top - $('.site-header').height()
      }, 'slow', function () {
        contactForm.find('input[name=fullname]').focus();
      });
    });

    // $(window).load(() => {
    //   const syllabusCat = $('.syllabus-items-categories .item-category.force');
    //
    //   if (syllabusCat.length) {
    //     const idx = syllabusCat.data('idx');
    //     $(`.syllabus-items-list .syllabus-item[data-idx=${idx}]`).show();
    //   }
    // });

    // $('.syllabus-items-categories .item-category').on('click', function (e) {
    //   e.preventDefault();
    //
    //   const idx = $(this).data('idx');
    //
    //   $('.syllabus-items-categories .item-category').not($(this))
    //     .removeClass('active');
    //
    //   $(this).addClass('active');
    //
    //   $(`.syllabus-items-list .syllabus-item`).hide();
    //   $(`.syllabus-items-list .syllabus-item[data-idx=${idx}]`).show();
    // });

    // Faq Questions
    $('.course-faq .faq-items-wrap .question-item .question-item-head').on('click', function () {
      const item = $(this).parent();

      $('.question-item').not(item)
        .removeClass('active')
        .find('.question-item-body')
        .slideUp(200);

      item.toggleClass('active');
      item.find('.question-item-body').stop().slideToggle(200);
    });

    // Mobile who fits toggle
    $('.who-fits-blocks .fits-block-item .block-title').on('click', function () {
      if ($(window).width() > 767) {
        return;
      }

      const item = $(this).parent();

      $('.fits-block-item').not(item)
        .removeClass('active')
        .find('.block-info')
        .slideUp(200);

      item.toggleClass('active');
      item.find('.block-info').stop().slideToggle(200);
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCourse.js